import { Playground, Props } from 'docz';
import { ArrowDownCircle, GitHub, Minimize, Minimize2, Figma, LifeBuoy, XCircle, X } from "../../../../../src/index.ts";
import Icon from "../../../../../src/components/Icon/Icon.tsx";
import * as React from 'react';
export default {
  Playground,
  Props,
  ArrowDownCircle,
  GitHub,
  Minimize,
  Minimize2,
  Figma,
  LifeBuoy,
  XCircle,
  X,
  Icon,
  React
};